<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Row :gutter="32">
                    <Col span="24">
                        <FormItem label="项目名称" prop="name">
                            <Input v-model="Forms.name" clearable placeholder="项目名称" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目类型" prop="type_id">
                            <Select v-model="Forms.type_id" clearable filterable  placeholder="项目类型">
                                <Option v-for="(item,index) in typeList" :key="index" :value="item.type_id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="负责人" prop="head_id">
                            <Select v-model="Forms.head_id" clearable filterable  placeholder="负责人">
                                <Option v-for="(item,index) in userList" :key="index" :value="item.admin_id">{{item.real_name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="甲方" prop="customer_id">
                            <Select v-model="Forms.customer_id" clearable filterable placeholder="甲方" class="width-70">
                                <Option v-for="(item,index) in customerList" :key="index" :value="item.id">{{item.company}}</Option>
                            </Select>
                            &nbsp;<Button type="primary" class="width-27" ghost @click="getContact">联系方式</Button>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="联系人" prop="customer_real_name">
                            <Input v-model="Forms.customer_real_name" clearable placeholder="不填则使用甲方默认联系人" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="联系电话" prop="customer_mobile">
                            <Input v-model="Forms.customer_mobile" clearable placeholder="不填则使用甲方默认联系电话" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="微信号" prop="customer_wechat">
                            <Input v-model="Forms.customer_wechat" clearable placeholder="不填则使用甲方默认微信号" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目金额" prop="money">
                            <Input v-model="Forms.money" type="number" clearable placeholder="如：10000" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="合同金额" prop="contract_money">
                            <Input v-model="Forms.contract_money" type="number"  clearable placeholder="如：10000" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="签订人" prop="contract_signa_name">
                            <Input v-model="Forms.contract_signa_name" clearable placeholder="如：张三+电话" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="合同有效期" prop="signa_time">
                            <DatePicker type="daterange" format="yyyy-MM-dd" v-model="Forms.signa_time" placement="bottom-end" placeholder="合同有效期" class="width-100"  />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="合同资料" prop="contract_file">
                            <Input v-model="Forms.contract_file" disabled>
                                <template #append>
                                    <div class="f-center">
                                        <Upload
                                            :show-upload-list="false"
                                            :action="upload_url"
                                            :headers = "{'token': $store.state.token}"
                                            :format="['xls','xlsx','rar','zip','doc','docx','txt','docx','jpg','jpeg','png']"
                                            :max-size="50 * 1024"
                                            :on-success="handleSuccess"
                                            :on-format-error="handleFormatError"
                                            :on-exceeded-size="handleMaxSize">
                                            <a href="javascript:void(0);" class="text-primary"><Icon type="md-cloud-upload" />上传</a>
                                        </Upload>
                                        <Divider type="vertical" />
                                        <a href="javascript:void(0);" @click="FileDelete()" class="text-danger"><Icon type="md-trash" />删除</a>
                                        <Divider type="vertical" />
                                        <a href="javascript:void(0);" @click="FileDownload()" class="text-violet"><Icon type="md-download" />下载</a>
                                    </div>
                                </template>
                            </Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目工期" prop="project_cycle">
                            <Input v-model="Forms.project_cycle" clearable placeholder="如：2个月" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="项目说明" prop="project_desc">
                            <Input v-model="Forms.project_desc" type="textarea" :rows="8" clearable placeholder="项目说明" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="项目备注" prop="remark">
                            <Input v-model="Forms.remark" type="textarea" :rows="4" clearable placeholder="备注信息" />
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">保存</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {getProjectConfig, saveProject, getProjectDetail} from "@/apis/project";
import {getCustomerContact} from "@/apis/customer";

export default {
    name: 'ProjectCreate',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '新增项目',
            isBox : false,
            typeList: [],
            customerList: [],
            userList: [],

            upload_url : this.$uploadFileApi,
            site_url : this.$siteApi,

            Forms : {
                project_id: '',
                name: '',
                type_id: '',
                head_id: '',
                customer_id: '',
                customer_real_name: '',
                customer_mobile: '',
                customer_wechat: '',
                budget_money: '',
                project_cycle: '',
                contract_money: '',
                money: '',
                contract_signa_name: '',
                signa_time: [],
                contract_file: '',
                project_file: '',
                project_desc: '',
                status: 1,
                remark: ''
            },
            Rules : {
                name: [
                    { required: true, type: 'string',  message: '请输入项目名称', trigger: 'blur' }
                ],
                type_id: [
                    { required: true, type: 'number',  message: '请选择项目类型', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                head_id: [
                    { required: true, type: 'number',  message: '请选择负责人', trigger: 'change',  transform(value) { return parseInt(value)}}
                ],
                customer_id: [
                    { required: true, type: 'number',  message: '请选择负甲方', trigger: 'change',  transform(value) { return parseInt(value)}}
                ],
                customer_real_name: [
                    { required: true, type: 'string',  message: '请输入联系人', trigger: 'blur' }
                ],
                customer_mobile: [
                    { required: true, type: 'string',  message: '请输入联系人电话', trigger: 'blur' }
                ],
                contract_money: [
                    { required: true, type: 'number',  message: '请输入合同金额', trigger: 'blur',  transform(value) { return parseFloat(value)}},
                    { type: 'number', min: 1, message: '合同金额必须大于等于1元', trigger: 'blur' }
                ],
                money: [
                    { required: true, type: 'number',  message: '请输入项目实际金额', trigger: 'blur',  transform(value) { return parseFloat(value)}},
                    { type: 'number', min: 1, message: '项目实际金额必须大于等于1元', trigger: 'blur' }
                ],
                contract_signa_name: [
                    { required: true, message: '请输入签订人信息 格式如：张三+电话', trigger: 'blur' }
                ],
                signa_time: [
                    { required: true, type: 'array', min: 1,  message: '请选择合同有效期', trigger: 'change' }
                ],
                contract_file: [
                    { required: true, type: 'string',  message: '请上传合同资料', trigger: 'blur' }
                ],
            }
        }
    },
    methods: {

        /**
         功能：
         time: 2025/12/19 15:40
         **/
        getContact(){
            let that = this;
            if(!that.Forms.customer_id){
                that.$Message.error({ background: true,duration:3, content: '请选择甲方'});
                return;
            }
            getCustomerContact(that.Forms.customer_id).then(e => {
                let data = e.data;
                that.Forms.customer_real_name = data.name ?? '';
                that.Forms.customer_mobile = data.mobile ?? '';
                that.Forms.customer_wechat = data.wechat ?? '';
            })
        },
        /**
         功能：下载
         time: 2025/12/17 10:48
         **/
        FileDownload(){
            let that = this;
            if(that.Forms.contract_file){
               //下载文件
                const fileUrl = that.site_url + that.Forms.contract_file; // 文件的URL地址
                const parts = fileUrl.split('/');
                const fileName = parts[parts.length - 1];
                const link = document.createElement('a');
                link.href = fileUrl;
                link.setAttribute('download', fileName);
                link.click();
            }else{
                that.$Message.error({ background: true,duration:3, content: '请上传文件'});
            }
        },
        /**
         功能：图片文件
         time: 2025/12/17 10:48
         **/
        FileDelete(){
            let that = this;
            that.Forms.contract_file = "";
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleSuccess(res){
            let that = this;
            if(res.code == 100){
                this.Forms.contract_file = res.data.url;
            }else{
                that.$Message.error({ background: true,duration:3, content: res.msg});
            }
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 xls | xlsx | rar | zip | doc | docx | txt | jpg | jpeg | png 文件 ' });
            return false;
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '文件大小不能超出 50M' });
            return false;
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        GetConfig(){
            let that = this;
            getProjectConfig().then(e=>{
                that.typeList = e.data.typeList ?? [];
                that.customerList = e.data.customerList ?? [];
                that.userList = e.data.userList ?? [];
            })
        },

        /**
         功能：
         time: 2025/12/17 16:04
         **/
        GetDetail(project_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getProjectDetail(project_id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    that.Forms[v] = data[v];
                    if(v === 'type_id' || v === 'customer_id' || v === 'head_id' ) {
                        that.Forms[v] = parseInt(data[v]);
                    }else if(v === 'signa_time' ) {
                        that.Forms[v] = data[v] ?? [];
                    }else{
                        that.Forms[v] = data[v];
                    }
                }
            })
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        add(){
            this.isBox = true;
            this.GetConfig();
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        edit(project_id){
            this.isBox = true;
            this.title = '编辑项目';
            this.GetConfig();
            if(project_id) this.GetDetail(project_id);
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    saveProject(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        FormReset(){
            this.isBox = false;
            this.title = '新增项目';
            this.$refs['Forms'].resetFields();
            this.Forms.typeList = [];
            this.Forms.customerList = [];
            this.Forms.userList = [];
            this.Forms.project_id = '';
            this.Forms.status = 1;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.forms {
    .ivu-form-item {
        //margin-bottom: 0 !important;
    }
}
.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.spin-text {
    font-size: 12px;
    padding-top: 10px;
}
</style>
